import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PilotPayHttpClient } from '../../core';
import { INote, IPayCategory } from './pay-categories.type';
/**
 * PayCategoriesService
 */
@Injectable()
export class PayCategoriesService {
	constructor(http: PilotPayHttpClient) {
		this.http = http;
	}

	private http: PilotPayHttpClient;

	public getPayCategories(includeFuture: boolean = false, includeNotes: boolean = false): Observable<IPayCategory[]> {
		let url: string = '/api/pay-categories';

		if (includeFuture) {
			url += `?includeFuture=${includeFuture}`;
		}

		if (includeNotes) {
			url += `?includeNotes=${includeNotes}`;
		}

		return this.http.getRequest(url);
	}

	public getPayArchivedCategories(): Observable<Object> {
		return this.http.getRequest('/api/pay-categories/archived');
	}

	public getPayCategory(id: string): Observable<Object> {
		return this.http.getRequest(`/api/pay-categories/${id}`);
	}

	public getPayCategoryByDate(id: string, date: string): Observable<Object> {
		return this.http.getRequest(`/api/pay-categories/${id}/by-date?date=${date}`);
	}

	public deletePayCategory(id: string, effectiveDate: string): Observable<Object> {
		return this.http.deleteRequest(`/api/pay-categories/${id}?date=${effectiveDate}`);
	}

	public createPayCategory(paylod: IPayCategory): Observable<Object> {
		return this.http.postRequest('/api/pay-categories', paylod);
	}

	public updatePayCategory(id: string, paylod: IPayCategory): Observable<Object> {
		return this.http.putRequest(`/api/pay-categories/${id}`, paylod);
	}

	public createPayCategoryNote(payCategoryId: number, paylod: INote): Observable<Object> {
		return this.http.postRequest(`/api/pay-categories/${payCategoryId}/notes`, paylod);
	}

	public getPayCategoryNote(payCategoryId: string, payCategoryNoteSettingId: string): Observable<Object> {
		return this.http.getRequest(`/api/pay-categories/${payCategoryId}/notes/${payCategoryNoteSettingId}`);
	}

	public getWorkDayCategoryList(): Observable<Object> {
		return this.http.getRequest('/api/pay-categories/workday-categories');
	}

	public getMinimumEffectiveDate(payCategoryId: string): Observable<Object> {
		return this.http.getRequest(`/api/pay-categories/${payCategoryId}/minimum-effective-date`);
	}

	public getPayCategoryHistory(payCategoryId: string): Observable<Object> {
		return this.http.getRequest(`/api/pay-categories/${payCategoryId}/history`);
	}

	public getPayCategoryFutureChanges(payCategoryId: string): Observable<Object> {
		return this.http.getRequest(`/api/pay-categories/${payCategoryId}/scheduled-changes`);
	}

	public deletePayCategoryFutureChanges(payCategoryId: string): Observable<Object> {
		return this.http.deleteRequest(`/api/pay-categories/${payCategoryId}/scheduled-changes`);
	}

	public updatePayCategoryNote(
		payCategoryId: string,
		payCategoryNoteSettingId: number,
		paylod: INote
	): Observable<Object> {
		return this.http.putRequest(`/api/pay-categories/${payCategoryId}/notes/${payCategoryNoteSettingId}`, paylod);
	}

	public deletePayCategoryNote(
		payCategoryId: string,
		payCategoryNoteSettingId: number,
		effectiveDate: string
	): Observable<Object> {
		return this.http.deleteRequest(
			`/api/pay-categories/${payCategoryId}/notes/${payCategoryNoteSettingId}?date=${effectiveDate}`
		);
	}
}
